import { Dialog, LinearProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { userLicenseService } from "../../_services/userLicense.service";
import { UserProfileMediaLicensePdf } from "./userProfile-mediaLicensePdf";
import { UserProfileMinorLicensePdf } from "./userProfile-minorLicensePdf";
import { UserProfileOfficialLicensePdf } from "./userProfile-officialLicensePdf";
import { UserProfileOneDayLicensePdf } from "./userProfile-oneDayLicensePdf";
import { UserProfileRacingLicensePdf } from "./userProfile-racingLicensePdf";
import { UserLicenseTypeEnum } from "../../_common/enum/forms/userLicenseType.enum";
import { UserProfileGenericLicensePdf } from "./userProfile-genericLicensePdf";

export function UserProfileLicenseView(params: {
    token?: string
    onClose?(): void
}) {

    const { userId, token } = useParams<{ userId: string, token: string }>();

    var _token = token || params.token || "";

    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<any>({});
    let navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, [userId, _token]);

    function fetchData() {
        if (!_token) return;

        setIsLoading(true);
        return userLicenseService
            .getCurrentUserLicenseInfo(_token)
            .then(
                (json) => {
                    if (json) {
                        setData(json);
                    }
                }
            )
            .finally(() => setIsLoading(false));
    }

    return (
        <>
            <Dialog className={"smallerDialog"} open={true} sx={{ margin: "0px" }} style={{ margin: "80px !important" }}>
                {isLoading && <LinearProgress />}
                {!isLoading && <>
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.CompetitionLicenceApplication &&
                        <UserProfileRacingLicensePdf data={data} />
                    }
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.Media &&
                        <UserProfileMediaLicensePdf data={data} />
                    }
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.Official &&
                        <UserProfileOfficialLicensePdf data={data} />
                    }
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.OneDayEvent &&
                        <UserProfileOneDayLicensePdf data={data} />
                    }
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.MinorEntrant &&
                        <UserProfileMinorLicensePdf data={data} />
                    }
                    {(data && data.licenseTypeId) === UserLicenseTypeEnum.Questionnaire &&
                        <UserProfileGenericLicensePdf data={data} />
                    }
                    {/* <canvas id="licenseId" style={{ display: "block", margin: "auto", float: "left" }}></canvas> */}

                    <PrimaryButton variant="primary" type="button" onClick={() => { params.onClose ? params.onClose() : navigate("..") }}>Close</PrimaryButton>
                </>
                }
            </Dialog>
        </>
    );
}